/* eslint-disable react/no-unused-state */
/* eslint-disable react/no-danger */
import Editor from '@draft-js-plugins/editor';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { NavLink, withRouter } from 'react-router-dom';
import { monthNameDDYYYY } from '../date';

import 'draft-js/dist/Draft.css';

import {
  fetchPage, deletePage, fetchChapter, fetchNotebook, updateNotebook, fetchPersonalNotes, createPersonalNote, patchNotebook, deletePersonalNote, fetchPersonalNotebyPage,
} from '../../actions';
import loadPage from '../editor-components/load-page';
import plugins from '../editor-components/plugins';
import BookLink from './book-link';
import Reactions from './reactions';
import Comments from './comments';

const plug = plugins();

class Page extends Component {
  constructor(props) {
    super(props);
    this.state = {
      confirmDelete: false,
      addedQ: false,
      addedC: false,
    };
  }

  componentDidMount() {
    this.props.fetchPage(this.props.match.params.bookID, this.props.match.params.chapterID, this.props.match.params.pageID);
    this.props.fetchChapter(this.props.match.params.bookID, this.props.match.params.chapterID);
    this.props.fetchNotebook();
    this.props.fetchPersonalNotes();
    this.props.fetchPersonalNotebyPage(this.props.match.params.bookID, this.props.match.params.chapterID, this.props.match.params.pageID);

    const { notebook, currPersonalNote } = this.props;
    notebook.Queue?.forEach((Epage) => {
      if (Epage.id === this.props.match.params.pageID) this.setState({ addedQ: true });
    });

    if (currPersonalNote?.Page?.id === this.props.match.params.pageID) {
      this.setState({ addedC: true });
    }
  }

  allowEdit = () => {
    if (this.props.page?.Author?.id === this.props.author?.id) {
      return (
        <NavLink to={`/books/${this.props.match.params.bookID}/chapters/${this.props.match.params.chapterID}/pages/${this.props.match.params.pageID}/edit`}>
          <button type="submit">Edit</button>
        </NavLink>
      );
    } else return null;
  }

  allowDelete = () => {
    if (this.props.page?.Author?.id === this.props.author?.id) {
      if (this.state.confirmDelete) {
        return (
          <>
            <button type="submit" id="confirm-delete" onClick={this.handleDelete}>Confirm Delete</button>
            <button type="submit" onClick={this.deleteCancel}>Cancel</button>
          </>
        );
      } else {
        return <button type="submit" onClick={this.deleteConfirmation}>Delete</button>;
      }
    } else return null;
  }

  deleteConfirmation = () => {
    this.setState({ confirmDelete: true });
  }

  deleteCancel = () => {
    this.setState({ confirmDelete: false });
  }

  handleDelete = (bId, chId, pId) => {
    this.props.deletePage(this.props.match.params.bookID, this.props.match.params.chapterID, this.props.match.params.pageID, this.props.history);
  }

  handleQueueAdd = () => {
    const { notebook } = this.props;
    this.setState({ addedQ: true });

    notebook?.Queue?.push(this.props.match.params.pageID);
    this.props.updateNotebook(notebook);
  }

  handleQueueRemove = (pageID) => {
    this.setState({ addedQ: false });
    this.props.patchNotebook({ pageID });
  }

  handleCollectionAdd = () => {
    this.props.createPersonalNote(this.props.match.params.pageID);
    this.setState({ addedC: true });
  }

  handleCollectionDelete = () => {
    this.props.deletePersonalNote(this.props.currPersonalNote.id);
    this.setState({ addedC: false });
  }

  renderAuthor = () => {
    return (
      <div className="page-author">
        <NavLink to={`/profile/${this.props.page?.Author?.id}`}>
          <img className="profile-pic-small" alt="" src={this.props.page?.Author?.profpic} />
        </NavLink>
        <div className="author-and-date">
          <NavLink id="page-author-link" to={`/profile/${this.props.page?.Author?.id}`}>
            <p>{this.props.page?.Author?.name}</p>
          </NavLink>
          <p id="page-date">{monthNameDDYYYY(this.props?.page?.createdAt)}</p>
        </div>
      </div>
    );
  }

  renderQueueOptions = () => {
    if (this.state.addedQ) {
      return (
        <button type="button" className="removeFrom grey-button" onClick={() => this.handleQueueRemove(this.props.match.params.pageID)}>
          <p>Remove<span className="hide-small"> from Reading List</span></p>
          <i className="fas fa-glasses" />
        </button>
      );
    } else {
      return (
        <button type="button" className="addTo grey-button" onClick={this.handleQueueAdd}>
          <p>Add<span className="hide-small"> to Reading List</span></p>
          <i className="fas fa-glasses" />
        </button>
      );
    }
  }

  renderCollectionOptions = () => {
    if (this.state.addedC) {
      return (
        <button type="button" className="removeFrom grey-button" onClick={this.handleCollectionDelete}>
          <p>Remove<span className="hide-small"> From Your Collection</span></p>
          <i className="fas fa-book" />
        </button>
      );
    } else {
      return (
        <button type="button" className="addTo grey-button" onClick={this.handleCollectionAdd}>
          <p>Add<span className="hide-small"> to Your Collection</span></p>
          <i className="fas fa-book" />
        </button>
      );
    }
  }

  // buttons for saving page to queue or collection
  renderButtons = () => {
    if (this.props.loggedIn) {
      return (
        <div className="savePageButtons">
          {this.renderQueueOptions()}
          {this.renderCollectionOptions()}
        </div>
      );
    } else return <></>;
  }

  render() {
    return (
      <>
        <BookLink className="chapter-title-header" to={`/books/${this.props.match.params.bookID}/chapters/${this.props.match.params.chapterID}/pages`}>
          <p>{this.props?.page?.Chapter?.title}</p>
        </BookLink>

        <div className="story-container">
          <div className="story-title">
            <h1>{this.props.page?.title}</h1>
          </div>
          <div className="story-bar">
            {this.renderAuthor()}
            {this.renderButtons()}
          </div>

          <div id="story-header-line" />

          <div className="story-author-options">
            {this.allowEdit()}
            {this.allowDelete()}
          </div>

          <div className="noBorder">
            <Editor editorState={loadPage(this.props.page?.content)} plugins={plug.plugins} onChange={() => (null)} readOnly />
          </div>
        </div>
        <Reactions />
        <Comments />
      </>
    );
  }
}

const mapStateToProps = (state) => (
  {
    author: state.author.current,
    book: state.books.current,
    chapter: state.chapters.current,
    page: state.pages.current,
    notebook: state.notebook.current,
    personalNotes: state.personalNotes.all,
    currPersonalNote: state.personalNotes.current,
    loggedIn: state.auth.authenticated,
  }
);

export default withRouter(connect(mapStateToProps, {
  fetchPage, deletePage, fetchChapter, fetchNotebook, updateNotebook, fetchPersonalNotes, createPersonalNote, patchNotebook, deletePersonalNote, fetchPersonalNotebyPage,
})(Page));
